module.exports = __webpack_public_path__ + "static/media/card-primary.3f053d33.png";